module.exports = __webpack_public_path__ + "img/10406.67e5fade.jpg";